// import { useEffect } from "react";
// // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { Routes, Route } from "react-router-dom";
// import Nav from "./Component/Nav";
// import Footer from "./Component/Footer";
// import Home from "./Component/Home";
// import Whowearepage from "./Component/Whowearepage";
// import Contactus from "./Component/Contactus";
// import WhatWeDo from "./Component/WhatWeDo";
// import Aimlmodel from "./Component/Aimlmodel";
// import Nlp from "./Component/Nlp";
// import Dataengineering from "./Component/Dataengineering";
// import Webdev from "./Component/Webdev";
// import Erp from "./Component/Erp";
// import Customai from "./Component/Customai";
// import Engneeringdesignsolution from "./Component/Engneeringdesignsolution";
// import Industrialautomate from "./Component/Industrialautomate";
// import Digitalfactory from "./Component/Digitalfactory";
// import Dmspage from "./Component/Dmspage";
// import Gdspage from "./Component/Gdspage";
// // import AboutUs from "./Component/AboutUs";
// import Ms from "./Component/Ms";
// import Mobileautomation from "./Component/Mobileautomation";
// import Lmspage from "./Component/Lmspage";
// import Billingsys from "./Component/Billingsys";
// import Hrmspage from "./Component/Hrmspage";
// import Banking from "./Component/Banking";
// import Healthsci from "./Component/Healthsci";
// import Techmedia from "./Component/Techmedia";
// import Hitech from "./Component/Hitech";
// import Software from "./Component/Software"; 
// import Careerpage from "./Component/Careerpage";
// import Careerform from "./Component/Careerform";
// import  Reactblog from "./Component/Reactblog";
// import  Blogpwa from "./Component/Blogpwa";
// import  Blogautomation from "./Component/Blogautomation";
// import  Blogintel from "./Component/Blogintel";
// import  Blogcloud from "./Component/Blogcloud";
// import  Blogwebsecure from "./Component/Blogwebsecure";
//  import  Articleai from "./Component/Articleai";
//  import  Blogdigital from "./Component/Blogdigital";
//  import { LoaderProvider } from "./Context/LoaderProvider.jsx";
 


// function App() {
  

  
//   return (
//     <div>
//        <LoaderProvider>
//       {/* <Router> */}
//         <Nav />
//         <Routes>
//           <Route path="/" element={<Home />} />
//           {/* <Route path="/about-us" element={<AboutUs />}></Route> */}
//           <Route path="/who-we-are" element={<Whowearepage />}></Route>
//           <Route path="/contactus" element={<Contactus />}></Route>
//           <Route path="/what-we-do" element={<WhatWeDo />}></Route>
//           <Route path="/aimlmodel" element={<Aimlmodel />}></Route>
//           <Route path="/nlp" element={<Nlp />}></Route>
//           <Route path="/dataengineering" element={<Dataengineering />}></Route>
//           <Route path="/webdev" element={<Webdev />}></Route>
//           <Route path="/erp" element={<Erp />}></Route>
//           <Route path="/customai" element={<Customai />}></Route>
//           <Route
//             path="/engneeringdesignsolution"
//             element={<Engneeringdesignsolution />}
//           ></Route>
//           <Route
//             path="/industrialautomate"
//             element={<Industrialautomate />}
//           ></Route>
//           <Route path="/digitalfactory" element={<Digitalfactory />}></Route>
//           <Route path="/dmspage" element={<Dmspage />}></Route>
//           <Route path="/gdspage" element={<Gdspage />}></Route>
//           <Route path="/ms" element={<Ms/>}></Route>
//           <Route
//             path="/mobileautomation"
//             element={<Mobileautomation />}
//           ></Route>
//           <Route path="/lmspage" element={<Lmspage />}></Route>
//           <Route path="/billingsys" element={<Billingsys />}></Route>
//           <Route path="/hrmspage" element={<Hrmspage />}></Route>
//           <Route path="/banking" element={<Banking />}></Route>
//           <Route path="/hitech" element={<Hitech/>}></Route>

//           <Route path="/healthsci" element={<Healthsci/>}></Route>
//           <Route path="/software" element={<Software/>}></Route>
//           <Route path="/careerpage" element={<Careerpage/>}></Route>
//          <Route path="/careerform" element={<Careerform/>}></Route>
// <Route path="/reactblog" element={< Reactblog/>}></Route>
//         <Route path="/blogpwa" element={<Blogpwa/>}></Route> 
//         <Route path="/blogautomation" element={<Blogautomation/>}></Route>
// <Route path="/blogintel" element={<Blogintel/>}></Route>
// <Route path="/blogcloud" element={<Blogcloud/>}></Route>
// <Route path="/blogwebsecure" element={<Blogwebsecure/>}></Route>
// <Route path="/articleai" element={<Articleai/>}></Route>
// <Route path="/blogdigital" element={<Blogdigital/>}></Route>

        
//         </Routes>
        

//         <Footer />
//       {/* </Router> */}
//       </LoaderProvider>
//     </div>
//   );
// }

// export default App;



import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Nav from "./Component/Nav";
import Footer from "./Component/Footer";
import Home from "./Component/Home";
import Whowearepage from "./Component/Whowearepage";
import Contactus from "./Component/Contactus";
import WhatWeDo from "./Component/WhatWeDo";
import Aimlmodel from "./Component/Aimlmodel";
import Nlp from "./Component/Nlp";
import Dataengineering from "./Component/Dataengineering";
import Webdev from "./Component/Webdev";
import Erp from "./Component/Erp";
import Customai from "./Component/Customai";
import Engneeringdesignsolution from "./Component/Engneeringdesignsolution";
import Industrialautomate from "./Component/Industrialautomate";
import Digitalfactory from "./Component/Digitalfactory";
import Dmspage from "./Component/Dmspage";
import Gdspage from "./Component/Gdspage";
import Ms from "./Component/Ms";
import Mobileautomation from "./Component/Mobileautomation";
import Lmspage from "./Component/Lmspage";
import Billingsys from "./Component/Billingsys";
import Hrmspage from "./Component/Hrmspage";
import Banking from "./Component/Banking";
import Healthsci from "./Component/Healthsci";
import Techmedia from "./Component/Techmedia";
import Hitech from "./Component/Hitech";
import Software from "./Component/Software"; 
import Careerpage from "./Component/Careerpage";
import Careerform from "./Component/Careerform";
import Reactblog from "./Component/Reactblog";
import Blogpwa from "./Component/Blogpwa";
import Blogautomation from "./Component/Blogautomation";
import Blogintel from "./Component/Blogintel";
import Blogcloud from "./Component/Blogcloud";
import Blogwebsecure from "./Component/Blogwebsecure";
import Articleai from "./Component/Articleai";
import Blogdigital from "./Component/Blogdigital";

import CustomCursor from "./Component/CustomCursor";
import Bottomtotop from "./Component/Bottomtotop";
import Privacypolicy from "./Component/Privacypolicy.js";
import ScrollToTop from "./Component/ScrollToTop";
function App() {
  return (
    <div>
      {/* <LoaderProvider> */}
        {/* Custom Cursor */}
        {/* <CustomCursor /> */}

        {/* Navigation */}
        <Nav />

        {/* Routes */}
         <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/who-we-are" element={<Whowearepage />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/aimlmodel" element={<Aimlmodel />} />
          <Route path="/nlp" element={<Nlp />} />
          <Route path="/dataengineering" element={<Dataengineering />} />
          <Route path="/webdev" element={<Webdev />} />
          <Route path="/erp" element={<Erp />} />
          <Route path="/customai" element={<Customai />} />
          <Route path="/engneeringdesignsolution" element={<Engneeringdesignsolution />} />
          <Route path="/industrialautomate" element={<Industrialautomate />} />
          <Route path="/digitalfactory" element={<Digitalfactory />} />
          <Route path="/dmspage" element={<Dmspage />} />
          <Route path="/gdspage" element={<Gdspage />} />
          <Route path="/ms" element={<Ms />} />
          <Route path="/mobileautomation" element={<Mobileautomation />} />
          <Route path="/lmspage" element={<Lmspage />} />
          <Route path="/billingsys" element={<Billingsys />} />
          <Route path="/hrmspage" element={<Hrmspage />} />
          <Route path="/banking" element={<Banking />} />
          <Route path="/hitech" element={<Hitech />} />
          <Route path="/healthsci" element={<Healthsci />} />
          <Route path="/software" element={<Software />} />
          <Route path="/careerpage" element={<Careerpage />} />
          <Route path="/careerform" element={<Careerform />} />
          <Route path="/reactblog" element={<Reactblog />} />
          <Route path="/blogpwa" element={<Blogpwa />} />
          <Route path="/blogautomation" element={<Blogautomation />} />
          <Route path="/blogintel" element={<Blogintel />} />
          <Route path="/blogcloud" element={<Blogcloud />} />
          <Route path="/blogwebsecure" element={<Blogwebsecure />} />
          <Route path="/articleai" element={<Articleai />} />
          <Route path="/blogdigital" element={<Blogdigital />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
        </Routes>

        {/* Footer */}
        <Footer />
        <Bottomtotop/>
    
    </div>
  );
}

export default App;

